/**
 * Anchor of the partner page's tab strip. Everything that opens a completeness section scrolls
 * here first, so a row that has no anchor of its own still lands on the tabs rather than nowhere.
 */
export const p360TabsIds = 'P360Tabs'
